
import React, { useState } from 'react';

const FAQSection = () => {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const faqs = [
    {
      question: 'What are peptides and how do they work?',
      answer: 'Peptides are short chains of amino acids that act as signaling molecules in the body. They work by binding to specific receptors and triggering various biological processes such as hormone production, tissue repair, immune function, and cellular regeneration. Our therapeutic peptides are designed to optimize these natural processes for enhanced health and performance.'
    },
    {
      question: 'Are peptides safe for long-term use?',
      answer: 'When prescribed and monitored by qualified medical professionals, peptides have an excellent safety profile. Most peptides are naturally occurring in the body or bioidentical to natural peptides. We conduct comprehensive health assessments and regular monitoring to ensure safe and effective treatment. Side effects are typically minimal and temporary.'
    },
    {
      question: 'How quickly will I see results from peptide therapy?',
      answer: 'Results vary depending on the specific peptides used and individual factors. Many patients notice initial improvements within 2-4 weeks, with more significant benefits becoming apparent after 2-3 months of consistent therapy. Some effects like improved sleep and energy may be noticed sooner, while changes in body composition and anti-aging benefits may take longer.'
    },
    {
      question: 'How are peptides administered?',
      answer: 'Most therapeutic peptides are administered via subcutaneous injection, similar to insulin injections for diabetics. The injections are typically done with very small needles and are relatively painless. Some peptides may be available in oral, nasal spray, or topical forms. We provide comprehensive training on proper injection techniques and ongoing support.'
    },
    {
      question: 'Can peptides be combined with other treatments?',
      answer: 'Yes, peptides often work synergistically with other treatments and can be safely combined with hormone therapy, IV vitamin therapy, and other wellness protocols. We carefully evaluate all your current treatments and medications to ensure safe and effective combinations. Many patients find that peptides enhance the benefits of their existing health regimens.'
    },
    {
      question: 'Do I need a prescription for peptide therapy?',
      answer: 'Yes, therapeutic peptides require a prescription from a licensed medical provider. Our process includes a comprehensive medical evaluation, laboratory testing, and ongoing medical supervision. This ensures you receive the appropriate peptides for your specific needs and that your treatment is safe and effective.'
    },
    {
      question: 'What is the cost of peptide therapy?',
      answer: 'Peptide therapy costs vary depending on the specific peptides prescribed, dosages, and treatment duration. Our plans range from $399-$999 per month and include medical supervision, laboratory monitoring, and ongoing support. We believe in transparent pricing and will provide detailed cost information during your consultation.'
    },
    {
      question: 'Are there any contraindications for peptide therapy?',
      answer: 'While peptides are generally safe, certain medical conditions or medications may be contraindications. These include active cancer, pregnancy, breastfeeding, and certain autoimmune conditions. During your consultation, we\'ll review your complete medical history to determine if peptide therapy is appropriate for you and identify any potential contraindications.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 lg:mb-6">
            <strong>Peptide Therapy</strong> FAQ
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 leading-relaxed">
            Get answers to the most common questions about peptide therapy and how it can benefit your health.
          </p>
        </div>

        <div className="space-y-4 lg:space-y-6">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl overflow-hidden">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 lg:px-8 py-4 lg:py-6 text-left flex justify-between items-center hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <h3 className="text-lg lg:text-xl font-semibold text-gray-900 pr-4">
                  {faq.question}
                </h3>
                <i className={`ri-${openFAQ === index ? 'subtract' : 'add'}-line text-2xl text-blue-600 flex-shrink-0`}></i>
              </button>
              
              {openFAQ === index && (
                <div className="px-6 lg:px-8 pb-4 lg:pb-6">
                  <p className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 lg:mt-16 text-center">
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-6 lg:p-8 text-white">
            <h3 className="text-xl lg:text-2xl font-bold mb-4">
              Still Have Questions?
            </h3>
            <p className="text-lg mb-6 opacity-90">
              Our peptide therapy experts are here to help you understand how peptides can transform your health.
            </p>
            <button className="bg-white text-blue-600 px-8 py-4 rounded-xl font-semibold hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300 whitespace-nowrap cursor-pointer">
              Schedule Free Consultation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
